import { isBoolean } from 'lodash-es';
import datePresetOptions from '../datePresets';

export default {
  name: 'date_created',
  label: 'Date Created',
  fetchOptions: async () => ({
    data: datePresetOptions,
  }),
  getMessage: async (value, cb) => {
    if (isBoolean(value)) {
      cb(value);
    }

    let presetNames = value;

    if (typeof presetNames === 'string') {
      presetNames = presetNames.split(',');
    }

    if (Array.isArray(presetNames) === false) {
      presetNames = [presetNames];
    }

    try {
      const labels = presetNames.map((name) => {
        const preset = datePresetOptions.find((presetItem) => presetItem.value === name);

        return preset ? preset.label : name;
      });

      return Promise.resolve(cb(labels));
    } catch (error) {
      return Promise.resolve(cb(value));
    }
  },
  filters: [
    {
      name: 'date_created_preset',
      label: 'Date created preset',
      input: 'chips',
      value: null,
      message: (value) => `**date created** is **${value}**`,
    },
    {
      name: 'date_created_is',
      label: 'Date created is',
      input: 'date',
      value: null,
      message: (value) => `**date created** is **${value}**`,
    },
    {
      name: 'date_created_is_not',
      label: 'Date created is not',
      input: 'date',
      value: null,
      message: (value) => `**date created** is not **${value}**`,
    },
    {
      name: 'date_created_after',
      label: 'Date created is after',
      input: 'date',
      value: null,
      message: (value) => `**date created** is after **${value}**`,
    },
    {
      name: 'date_created_before',
      label: 'Date created is before',
      input: 'date',
      value: null,
      message: (value) => `**date created** is before **${value}**`,
    },
    {
      name: 'date_created_between',
      label: 'Date created is between',
      input: 'date-range',
      value: [],
      message: (value) =>
        `**date created** is between **${value[0] || 'since'}** and **${value[1] || 'until'}**`,
    },
  ],
};
